exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1CXOBf4yLXbDsY8dAy3Cx0 {\n  min-height: 185px;\n}\n\np {\n  margin-bottom: 0;\n}\n", ""]);

// exports
exports.locals = {
	"ecgGraph": "_1CXOBf4yLXbDsY8dAy3Cx0"
};


//////////////////
// WEBPACK FOOTER
// /Users/travis/build/alivecor/kardia-pro/node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!/Users/travis/build/alivecor/kardia-pro/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/containers/KardiaRxEcgTable/KardiaRxEcgTable.css
// module id = 9567
// module chunks = 23